import React, { useEffect } from 'react';
import { Button, Typography, Box } from '@mui/material';
import { useAuth } from '../hooks/useAuth';
import { useNavigate } from 'react-router-dom';

const Login = () => {
  const { signIn, user, token, isTokenExpired } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    console.log('Checking navigation conditions:', { user, token, isTokenExpired: isTokenExpired(token) });

    // Only navigate to dashboard if user exists and token is valid
    if (user && token && !isTokenExpired(token)) {
      navigate('/');
    }
    // If token is expired, stay on login page for manual sign in
  }, [user, token, navigate, isTokenExpired]);

  const handleLogin = () => {
    signIn();
  };

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        height: '100vh',
      }}
    >
      <Typography variant="h4" sx={{ mb: 2 }}>
        Sign in with Google
      </Typography>
      <Button variant="contained" onClick={handleLogin}>
        Sign In
      </Button>
    </Box>
  );
};

export default Login;